<template>
  <div class="flex flex-wrap">
    <div class="w-full px-4">
      <!-- Hero -->
      <div class="rounded-2xl shadow-xl bg-white overflow-hidden mb-8 border border-gray-100">
        <div class="bg-respina-primary px-6 py-8 text-white">
          <h1 class="text-2xl md:text-3xl font-bold mb-1">Support</h1>
          <p class="text-respina-light text-sm opacity-90">
            Get help with RespinaBoard
          </p>
        </div>
      </div>

      <!-- Content -->
      <div class="rounded-2xl shadow-lg bg-white overflow-hidden border border-gray-100">
        <div class="p-6 md:p-8 space-y-8">

          <!-- Contact -->
          <section>
            <h2 class="text-lg font-bold text-gray-800 mb-3 flex items-center gap-2">
              <i class="fas fa-envelope text-respina-primary"></i>
              Contact Us
            </h2>
            <p class="text-gray-600 text-sm leading-relaxed mb-2">
              If you have questions, feedback, or need assistance, please reach out to our support team:
            </p>
            <ul class="text-sm text-gray-600 space-y-2 ml-1">
              <li>
                <i class="fas fa-envelope mr-2 text-gray-400"></i>
                Email: <a href="mailto:support@respina-board.com" class="text-respina-primary font-semibold hover:underline">support@respina-board.com</a>
              </li>
            </ul>
          </section>

          <!-- FAQ -->
          <section>
            <h2 class="text-lg font-bold text-gray-800 mb-3 flex items-center gap-2">
              <i class="fas fa-question-circle text-respina-primary"></i>
              Frequently Asked Questions
            </h2>
            <div class="space-y-4">
              <div>
                <h3 class="text-sm font-bold text-gray-700">How do I search for flights?</h3>
                <p class="text-sm text-gray-500 mt-1">Go to the Flight Board page. You can search by airport code, flight number, or airline name using the search bar at the top.</p>
              </div>
              <div>
                <h3 class="text-sm font-bold text-gray-700">How do I save favorites?</h3>
                <p class="text-sm text-gray-500 mt-1">After searching for an airport, flight, or airline, click the star icon to save it to your favorites. You need to be signed in to use this feature.</p>
              </div>
              <div>
                <h3 class="text-sm font-bold text-gray-700">How do I create an account?</h3>
                <p class="text-sm text-gray-500 mt-1">Click the "Login" button in the sidebar, then select "Create Account" to register with your email address.</p>
              </div>
              <div>
                <h3 class="text-sm font-bold text-gray-700">How do I delete my account?</h3>
                <p class="text-sm text-gray-500 mt-1">When signed in, click the "Delete Account" button at the bottom of the sidebar. This will permanently remove your account and all associated data.</p>
              </div>
              <div>
                <h3 class="text-sm font-bold text-gray-700">Is RespinaBoard free to use?</h3>
                <p class="text-sm text-gray-500 mt-1">Yes, RespinaBoard is completely free. You can search flights, view airport boards, and save favorites at no cost.</p>
              </div>
              <div>
                <h3 class="text-sm font-bold text-gray-700">What data do you collect?</h3>
                <p class="text-sm text-gray-500 mt-1">We only collect the information you provide during registration (email, name) and your saved favorites. See our <router-link to="/privacy" class="text-respina-primary hover:underline">Privacy Policy</router-link> for details.</p>
              </div>
            </div>
          </section>

          <!-- App Info -->
          <section>
            <h2 class="text-lg font-bold text-gray-800 mb-3 flex items-center gap-2">
              <i class="fas fa-info-circle text-respina-primary"></i>
              About RespinaBoard
            </h2>
            <p class="text-gray-600 text-sm leading-relaxed">
              RespinaBoard is a real-time flight tracking and airport board application.
              Search airports, monitor flight status, track airlines, and manage your travel favorites
              all in one place. Available on Web and iOS.
            </p>
          </section>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Support",
};
</script>
